// src/pages/ganeshutsav/GaneshUtsavHome.jsx
import React from 'react';

const GaneshUtsavHome = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>GaneshUtsav Home</h1>
      <p>This is a placeholder page for the GaneshUtsav (Hindu Religion Festival) module.</p>
    </div>
  );
};

export default GaneshUtsavHome;